import React, { memo } from "react";
import { CrossHairCursor } from "@chartLib/lib/coordinates";
import PropTypes from "prop-types";

const CrossHair = memo(
  ({
    themeColors,
    snapX = true,
    opacity = 0.3,
    strokeDasharray = "ShortDash",
    strokeWidth = 3,
  }) => {
    return (
      <CrossHairCursor
        stroke={themeColors?.crosshair || "#000000"}
        opacity={opacity}
        strokeDasharray={strokeDasharray}
        strokeWidth={strokeWidth}
        snapX={snapX}
      />
    );
  },
);

CrossHair.displayName = "CrossHair";

CrossHair.propTypes = {
  themeColors: PropTypes.object,
  snapX: PropTypes.bool,
  opacity: PropTypes.number,
  strokeDasharray: PropTypes.string,
  strokeWidth: PropTypes.number,
};

export default CrossHair;
